/**
 * DocuSeal signature statuses mapped to EntityList `Pill` tones, so a document's
 * state reads identically everywhere it appears (the documents list, the
 * "vincular firma existente" picker, ...). Statuses come from DocuSeal's own
 * submission states; anything unrecognized falls back to neutral.
 */
export const ESIGNATURE_STATUS_TONES = {
	pending: 'warn',
	completed: 'ok',
	declined: 'danger',
	expired: 'neutral',
};

export const getEsignatureStatusTone = (status) => ESIGNATURE_STATUS_TONES[status] || 'neutral';
